// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_ItemsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/orders/items/{order_id}
 *
 * List of items for an order, with attribute values and step progress.
 */
import type { Orders_ItemRow } from './Orders_ItemRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Orders_ItemsResponseDados = Orders_ItemRow[];

export type Orders_ItemsResponse = ApiResponse<Orders_ItemsResponseDados>;

registerResponseContract('Orders_ItemsResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_order_item_id:                          { type: 'number',  required: true },
      so_order_item_order_id:                    { type: 'number',  required: true },
      so_order_item_type:                        { type: 'string',  required: true },
      so_order_item_parent_item_id:              { type: 'number',  required: false },
      so_order_item_service_id:                  { type: 'number',  required: false },
      so_order_item_additional_service_id:       { type: 'number',  required: false },
      so_order_item_additional_service_price_id: { type: 'number',  required: false },
      so_order_item_priority_id:                 { type: 'number',  required: false },
      so_order_item_product_id:                  { type: 'number',  required: false },
      so_order_item_quantity:                    { type: 'number',  required: true },
      so_order_item_unit_price:                  { type: 'number',  required: true },
      so_order_item_description:                 { type: 'string',  required: false },
      so_order_item_discount_type:               { type: 'string',  required: false },
      so_order_item_discount_value:              { type: 'number',  required: false },
      so_order_item_total:                       { type: 'number',  required: true },
      so_order_item_deadline_days:               { type: 'number',  required: false },
      so_order_item_qrcode:                      { type: 'string',  required: false },
      so_order_item_franchise_id:                { type: 'number',  required: false },
      so_order_item_delivered_at:                { type: 'string',  required: false },
      so_order_item_expected_delivery_at:        { type: 'string',  required: false },
      so_order_item_created_at:                  { type: 'string',  required: true },
      so_service_name:                           { type: 'string',  required: false },
      so_priority_name:                          { type: 'string',  required: false },
      attributes: {
        type: 'array',
        required: false,
        items: {
          so_oiav_id:             { type: 'number',  required: true },
          so_oiav_order_item_id:  { type: 'number',  required: true },
          so_oiav_attribute_id:   { type: 'number',  required: true },
          so_oiav_value:          { type: 'string',  required: true },
          so_oiav_created_at:     { type: 'string',  required: true },
          so_item_attribute_name: { type: 'string',  required: true },
          so_item_attribute_type: { type: 'string',  required: true },
        },
      },
      item_display_status:                       { type: 'string',  required: false },
      step_total:                                { type: 'number',  required: false },
      step_completed:                            { type: 'number',  required: false },
      so_order_item_alerts:                      { type: 'string',  required: false },
      so_order_item_notes:                       { type: 'string',  required: false },
      so_order_item_service_label:               { type: 'string',  required: false },
    },
  },
})
